<template>
  <div>
    <div class="page-content">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
      >
        <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
          <div class="card">
            <div class="card-header">
              <h6
                class="card-title mb-0 float-start"
                style="padding-left: 25px"
              >
                Master Activity Detail
              </h6>
              <br />
            </div>

            <div class="card-body">
              <div class="form-wrapper position-relative">
                <!-- Overlay loading -->
                <div
                  v-if="isLoading"
                  class="form-overlay d-flex justify-content-center align-items-center"
                >
                  <div class="text-center">
                    <div
                      class="spinner-border text-primary mb-2"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <div>
                      <strong>{{ $t("loadingTxt") }}...</strong>
                    </div>
                  </div>
                </div>

                <form
                  class="forms-sample"
                  @submit.prevent="submitData"
                  method="POST"
                >
                  <div
                    class="d-flex justify-content-between align-items-baseline mb-2"
                  ></div>

                  <!-- category -->
                  <div class="row mb-3">
                    <label for="category" class="col-sm-2 col-form-label"
                      >Category</label
                    >
                    <div class="col-sm-10">
                      <v-select
                        v-model="forms.category"
                        label="label"
                        :reduce="(item) => item.value"
                        :class="{ 'is-invalid': errors.category }"
                        disabled
                      ></v-select>
                      <div v-if="errors.category">
                        <div
                          v-for="error in errors.category"
                          :key="error"
                          class="alert alert-primary p-2 py-1"
                          role="alert"
                        >
                          <small
                            class="text-muted fst-italic d-block mb-1"
                            style="font-size: 0.7rem"
                            >{{ error
                            }}<i data-feather="alert-circle" class="me-1"></i
                          ></small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <!-- job_no -->
                      <div class="row mb-3">
                        <label for="job_no" class="col-sm-4 col-form-label"
                          >Job No
                        </label>
                        <div class="col-sm-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="forms.job_no"
                            id="job_no"
                            placeholder="Job No"
                            :class="{ 'is-invalid': errors.job_no }"
                            readonly
                          />
                          <div v-if="errors.job_no">
                            <div
                              v-for="error in errors.job_no"
                              :key="error"
                              class="alert alert-primary p-2 py-1"
                              role="alert"
                            >
                              <small
                                class="text-muted fst-italic d-block mb-1"
                                style="font-size: 0.7rem"
                                >{{ error
                                }}<i
                                  data-feather="alert-circle"
                                  class="me-1"
                                ></i
                              ></small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- category_problem -->
                      <div class="row mb-3">
                        <label
                          for="category_problem"
                          class="col-sm-4 col-form-label"
                          >Category Problem
                        </label>
                        <div class="col-sm-8">
                          <v-select
                            v-model="forms.category_problem"
                            label="label"
                            :reduce="(item) => item.value"
                            :class="{ 'is-invalid': errors.category_problem }"
                            disabled
                          ></v-select>
                          <div v-if="errors.category_problem">
                            <div
                              v-for="error in errors.category_problem"
                              :key="error"
                              class="alert alert-primary p-2 py-1"
                              role="alert"
                            >
                              <small
                                class="text-muted fst-italic d-block mb-1"
                                style="font-size: 0.7rem"
                                >{{ error
                                }}<i
                                  data-feather="alert-circle"
                                  class="me-1"
                                ></i
                              ></small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- jenis_pekerjaan -->
                      <div class="row mb-3">
                        <label
                          for="jenis_pekerjaan"
                          class="col-sm-4 col-form-label"
                          >Jenis Pekerjaan
                        </label>
                        <div class="col-sm-8">
                          <v-select
                            v-model="forms.jenis_pekerjaan"
                            label="label"
                            :reduce="(item) => item.value"
                            :class="{ 'is-invalid': errors.jenis_pekerjaan }"
                            disabled
                          ></v-select>
                          <div v-if="errors.jenis_pekerjaan">
                            <div
                              v-for="error in errors.jenis_pekerjaan"
                              :key="error"
                              class="alert alert-primary p-2 py-1"
                              role="alert"
                            >
                              <small
                                class="text-muted fst-italic d-block mb-1"
                                style="font-size: 0.7rem"
                                >{{ error
                                }}<i
                                  data-feather="alert-circle"
                                  class="me-1"
                                ></i
                              ></small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- type_perbaikan -->
                      <div class="row mb-3">
                        <label
                          for="type_perbaikan"
                          class="col-sm-4 col-form-label"
                          >Type Perbaikan
                        </label>
                        <div class="col-sm-8">
                          <v-select
                            v-model="forms.type_perbaikan"
                            label="label"
                            :reduce="(item) => item.value"
                            :class="{ 'is-invalid': errors.type_perbaikan }"
                            disabled
                          ></v-select>
                          <div v-if="errors.type_perbaikan">
                            <div
                              v-for="error in errors.type_perbaikan"
                              :key="error"
                              class="alert alert-primary p-2 py-1"
                              role="alert"
                            >
                              <small
                                class="text-muted fst-italic d-block mb-1"
                                style="font-size: 0.7rem"
                                >{{ error
                                }}<i
                                  data-feather="alert-circle"
                                  class="me-1"
                                ></i
                              ></small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6">
                      <!-- description -->
                      <div class="row mb-3">
                        <label for="description" class="col-sm-4 col-form-label"
                          >Description</label
                        >
                        <div class="col-sm-8">
                          <textarea
                            class="form-control"
                            id="description"
                            placeholder="Description"
                            v-model="forms.description"
                            rows="3"
                            :class="{ 'is-invalid': errors.description }"
                            readonly
                          ></textarea>
                          <div v-if="errors.description">
                            <div
                              v-for="error in errors.description"
                              :key="error"
                              class="alert alert-primary p-2 py-1"
                              role="alert"
                            >
                              <small
                                class="text-muted fst-italic d-block mb-1"
                                style="font-size: 0.7rem"
                                >{{ error
                                }}<i
                                  data-feather="alert-circle"
                                  class="me-1"
                                ></i
                              ></small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- fr -->
                      <div class="row mb-3">
                        <label for="fr" class="col-sm-4 col-form-label">
                          Flat Rate
                          <!-- <small class="text-muted fst-italic d-block mb-1" style="font-size: 0.60rem;">
                          contoh format : 0.98
                        </small> -->
                        </label>
                        <div class="col-sm-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="forms.fr"
                            id="fr"
                            placeholder="format 0.000000"
                            :class="{ 'is-invalid': errors.fr }"
                            readonly
                          />
                          <div v-if="errors.fr">
                            <div
                              v-for="error in errors.fr"
                              :key="error"
                              class="alert alert-primary p-2 py-1"
                              role="alert"
                            >
                              <small
                                class="text-muted fst-italic d-block mb-1"
                                style="font-size: 0.7rem"
                                >{{ error
                                }}<i
                                  data-feather="alert-circle"
                                  class="me-1"
                                ></i
                              ></small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- target_leadtime -->
                      <div class="row mb-3">
                        <label
                          for="target_leadtime"
                          class="col-sm-4 col-form-label"
                          >Target Leadtime</label
                        >
                        <div class="col-sm-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="forms.target_leadtime"
                            id="target_leadtime"
                            placeholder="format 00:00:00, Jam:Menit:Detik"
                            :class="{ 'is-invalid': errors.target_leadtime }"
                            readonly
                          />
                          <div v-if="errors.target_leadtime">
                            <div
                              v-for="error in errors.target_leadtime"
                              :key="error"
                              class="alert alert-primary p-2 py-1"
                              role="alert"
                            >
                              <small
                                class="text-muted fst-italic d-block mb-1"
                                style="font-size: 0.7rem"
                                >{{ error
                                }}<i
                                  data-feather="alert-circle"
                                  class="me-1"
                                ></i
                              ></small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-footer">
                    <button
                      class="btn btn-warning text-black fw-bolder btn-icon-text"
                      @click="backForm"
                      type="button"
                    >
                      <i class="link-icon" data-feather="arrow-left"></i>
                      {{ $t("backMess") }}
                    </button>
                    <span
                      v-if="this.permision_role.method_update"
                      class="btn btn-primary float-end btn-sm"
                      @click="editData"
                    >
                      <i class="link-icon" data-feather="edit"></i>
                      Edit
                    </span>
                    <span
                      v-if="this.permision_role.method_update"
                      class="btn btn-primary float-end btn-sm"
                      @click="addData"
                      style="margin-right:10px"
                    >
                      <i class="link-icon" data-feather="plus"></i>
                      Create New Data
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!--end::card-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import moment from "moment";
// import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
// // import DateRangePicker from "vue2-daterange-picker";
// import multiselect from "vue-multiselect";
// import modalEskalasiFppk from "@/components/modal/modalEskalasiFppk.vue";

export default {
  name: "MasterActivityFppkDetail",
  props: {},
  components: {
    // DateRangePicker,
    //multiselect: multiselect,
    //"modal-eskalasi-fppk": modalEskalasiFppk,
  },
  data() {
    return {
      locale: {
        format: "dd mmm yyyy H:MM:ss",
      },

      opens: "center",
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      forms: {
        master_activity_id: "",
        category: "",
        job_no: "",
        description: "",
        fr: "",
        target_leadtime: "",
        category_problem: "",
        jenis_pekerjaan: "",
        type_perbaikan: "",
      },
      company: [],
    };
  },
  watch: {},
  methods: {
    addData() {
      window.location.href = "/fppk-master-activity/add";
    },
    
    editData() {
      var params = this.$onRandom(this.forms.master_activity_id);
      window.location.href = "/fppk-master-activity/edit/" + params;
    },

    loadData(id) {
      const baseURI =
        this.$settings.endPointFppk + "v1/master-activity-fppk/detail/" + id;
      return this.$http.get(baseURI).then((response) => {
        //console.log(response);
        this.forms = response.data.datas;
      }).catch(error => {
          if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
          }else{

            if (error.response) {
              if(error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else if (error.response.status === 401) {
                  this.$router.push("/authorized-error");
              }else{
                  this.$router.push('/page-not-found');
              }
            }

          }

        });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "MasterActivityController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      this.permision_role = rolePermision;
    },

    backForm() {
      window.location.href = "/fppk-master-activity";
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
  },
};
</script>
<style scoped></style>
